import { ConfusionMatrixBin } from './ConfusionMatrixBin'
import { ConfusionMatrixLegend } from './ConfusionMatrixLegend'
import { ConfusionMatrixTemplateTable } from './ConfusionMatrixTemplateTable'
import { ConfusionMatrixTitle } from './ConfusionMatrixTitle'

export interface ConfusionMatrixValues {
  truePositive: number
  falsePositive: number
  falseNegative: number
  trueNegative: number
}

export interface ConfusionMatrixChartProps {
  expectedTitle: string
  actualsTitle?: string
  values: ConfusionMatrixValues
  onClickBin?: (bin: 'true_positive' | 'true_negative' | 'false_positive' | 'false_negative') => void
}
export function ConfusionMatrixChart({
  expectedTitle,
  actualsTitle = 'Actuals',
  values,
  onClickBin,
}: ConfusionMatrixChartProps) {
  const totalAmount = Object.values(values).reduce((total, current) => total + current, 0)

  return (
    <ConfusionMatrixTemplateTable
      titleActual={<ConfusionMatrixTitle>{actualsTitle}</ConfusionMatrixTitle>}
      titleExpected={<ConfusionMatrixTitle isRotated>{expectedTitle}</ConfusionMatrixTitle>}
      tpBin={
        <ConfusionMatrixBin
          onClick={onClickBin ? () => onClickBin('true_positive') : undefined}
          value={values.truePositive}
          totalAmount={totalAmount}
        />
      }
      fpBin={
        <ConfusionMatrixBin
          onClick={onClickBin ? () => onClickBin('false_positive') : undefined}
          value={values.falsePositive}
          totalAmount={totalAmount}
        />
      }
      fnBin={
        <ConfusionMatrixBin
          onClick={onClickBin ? () => onClickBin('false_negative') : undefined}
          value={values.falseNegative}
          totalAmount={totalAmount}
        />
      }
      tnBin={
        <ConfusionMatrixBin
          onClick={onClickBin ? () => onClickBin('true_negative') : undefined}
          value={values.trueNegative}
          totalAmount={totalAmount}
        />
      }
      legend={<ConfusionMatrixLegend />}
      actualPositiveSum={formatNumber(values.truePositive + values.falseNegative)}
      actualNegativeSum={formatNumber(values.falsePositive + values.trueNegative)}
      expectedPositiveSum={formatNumber(values.truePositive + values.falsePositive)}
      expectedNegativeSum={formatNumber(values.falseNegative + values.trueNegative)}
    />
  )
}

const formatNumber = new Intl.NumberFormat('en-US', {
  notation: 'standard',
  compactDisplay: 'short',
  maximumFractionDigits: 2,
  useGrouping: true,
}).format
